'use strict';

// Requires a #city input in the dom
// <input type="text" id="zip" city-lookup ng-city-model="city" ng-country-model="country" ng-model="zip">
function cityLookup(commonService) {
  return {
    restrict: 'A',
    scope: {
      ngCityModel: '=',
      ngCountryModel: '='
    },
    link: (scope, el) => {
      let city = el.parents('body').find('#city');

      // first check if city is available on the page
      if (city.length) {
        el.bind('input propertychange paste', () => {
          // only fetch cities if the country is Norway
          if (scope.ngCountryModel === 'NORGE') {
            // limit zipcode to 4 chars
            if (el.val().length > 3) {
              // fetch data
              commonService.getCityByPostCode(el.val())
                .then((json) => json.data)
                .then((resp) => {
                  if (resp) {
                    // update the model
                    scope.ngCityModel = resp.city ? resp.city : 'OSLO';
                  }
                });
            }
          }
        });

        // select city input value on blur
        el.bind('blur', () => {
          city.select();
        });
      }
    }
  };
}

cityLookup.$inject = ['commonService'];

angular
  .module('sr.lookups', [])
  .directive('cityLookup', cityLookup);
